export default __webpack_public_path__ + "static/media/primary.438713135ba9b20351dbabd1660946d8.svg";